import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCalendar,
  faUserFriends,
  faPlus,
  faMinus,
  faCheck,
  faCheckCircle,
  faExclamationCircle,
  faAngleRight,
  faAngleLeft,
} from '@fortawesome/pro-light-svg-icons'

library.add(
  faCalendar,
  faUserFriends,
  faPlus,
  faMinus,
  faCheck,
  faCheckCircle,
  faExclamationCircle,
  faAngleRight,
  faAngleLeft,
);

Vue.component('font-awesome-icon', FontAwesomeIcon)
